import React from 'react';
import useRouter from 'Hooks/useRouter';
import urls from 'Source/urls';
import { DetectionType } from 'Generated/schema';

/**
 * Helps retrieve and create a new instance for rule creation
 */
function useRelationRule() {
  const { history } = useRouter();

  const relationRule = React.useCallback(
    (
      {
        id,
        analysisType: type = DetectionType.Rule,
        specVersion,
      }: {
        id: string;
        analysisType?: DetectionType;
        specVersion?: string;
      },
      relationOperation: 'clone' | 'inherit',
    ) => {
      history.push(
        urls.build.detections.create({
          type,
          relatedDetectionId: id,
          version: specVersion as 'v1',
          relationOperation,
        }),
      );
    },
    [history],
  );

  return { relationRule };
}

export default useRelationRule;
